module.exports = __webpack_public_path__ + "img/gift-11.a53306d4.jpg";